import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import brand from "@/config/brand";

// Import Spanish translations
import commonEs from "@/i18n/locales/es/common.json";
import navigationEs from "@/i18n/locales/es/navigation.json";
import gisEs from "@/i18n/locales/es/gis.json";
import pagesEs from "@/i18n/locales/es/pages.json";
import adminEs from "@/i18n/locales/es/admin.json";
import analyticsEs from "@/i18n/locales/es/analytics.json";
import orgAdminEs from "@/i18n/locales/es/org_admin.json";
import superadminEs from "@/i18n/locales/es/superadmin.json";
import timeclockEs from "@/i18n/locales/es/timeclock.json";

// Import English translations
import commonEn from "@/i18n/locales/en/common.json";
import navigationEn from "@/i18n/locales/en/navigation.json";
import gisEn from "@/i18n/locales/en/gis.json";
import pagesEn from "@/i18n/locales/en/pages.json";
import adminEn from "@/i18n/locales/en/admin.json";
import analyticsEn from "@/i18n/locales/en/analytics.json";
import orgAdminEn from "@/i18n/locales/en/org_admin.json";
import superadminEn from "@/i18n/locales/en/superadmin.json";
import timeclockEn from "@/i18n/locales/en/timeclock.json";

// Import Portuguese translations
import commonPt from "@/i18n/locales/pt/common.json";
import navigationPt from "@/i18n/locales/pt/navigation.json";
import gisPt from "@/i18n/locales/pt/gis.json";
import pagesPt from "@/i18n/locales/pt/pages.json";
import adminPt from "@/i18n/locales/pt/admin.json";
import analyticsPt from "@/i18n/locales/pt/analytics.json";
import orgAdminPt from "@/i18n/locales/pt/org_admin.json";
import superadminPt from "@/i18n/locales/pt/superadmin.json";
import timeclockPt from "@/i18n/locales/pt/timeclock.json";

i18next.use(initReactI18next).init({
  fallbackLng: "es",
  defaultNS: "common",
  ns: ["common", "navigation", "gis", "pages", "admin", "analytics", "org_admin", "superadmin", "timeclock"],
  interpolation: {
    escapeValue: false,
    defaultVariables: {
      appName: brand.name,
    },
  },
  resources: {
    es: {
      common: commonEs,
      navigation: navigationEs,
      gis: gisEs,
      pages: pagesEs,
      admin: adminEs,
      analytics: analyticsEs,
      org_admin: orgAdminEs,
      superadmin: superadminEs,
      timeclock: timeclockEs,
    },
    en: {
      common: commonEn,
      navigation: navigationEn,
      gis: gisEn,
      pages: pagesEn,
      admin: adminEn,
      analytics: analyticsEn,
      org_admin: orgAdminEn,
      superadmin: superadminEn,
      timeclock: timeclockEn,
    },
    pt: {
      common: commonPt,
      navigation: navigationPt,
      gis: gisPt,
      pages: pagesPt,
      admin: adminPt,
      analytics: analyticsPt,
      org_admin: orgAdminPt,
      superadmin: superadminPt,
      timeclock: timeclockPt,
    },
  },
});

export function I18nProvider({ children }: { children: React.ReactNode }) {
  return <I18nextProvider i18n={i18next}>{children}</I18nextProvider>;
}
